import {ResourceHourBalance} from '@cquential/api';
import {ResourceWithKeyedByDateObjects} from '@/types/api-object-extensions';
import {BalanceFilterType, BalanceFilterEnabled} from '@/components/FilterBar/types';

export class BalanceUtil {
    // Function to return on 'associative' object whit timeType id as key
    public static getBalancesFromResource(resource: ResourceWithKeyedByDateObjects): Record<number, ResourceHourBalance> {
        if (resource.balances) {
            return BalanceUtil.getBalancesFromUnmappedBalances(resource.balances);
        }

        return {};
    }

    public static getLeaveOverViewBalancesFromResource(resource: ResourceWithKeyedByDateObjects): Record<number, ResourceHourBalance> {
        if (resource.balances) {
            return BalanceUtil.getLeaveOverviewBalancesFromUnmappedBalances(resource.balances);
        }

        return {};
    }

    public static enabledBalances(enabledBalanceFilters: Record<string, BalanceFilterEnabled>, type: BalanceFilterType): Record<number, boolean> {
        const enabledBalances: Record<number, boolean> = {};
        for (const index in enabledBalanceFilters) {
            if (enabledBalanceFilters[index].type === type) {
                enabledBalances[enabledBalanceFilters[index].id] = enabledBalanceFilters[index].enabled;
            }
        }

        return enabledBalances;
    }

    private static getBalancesFromUnmappedBalances(balances: ResourceHourBalance[]): Record<number, ResourceHourBalance> {
        const mappedBalances: Record<number, ResourceHourBalance> = {};
        for (const balance of balances) {
            if (balance.timeType !== null && !mappedBalances[balance.timeType]) {
                mappedBalances[balance.timeType] = balance;
            }
        }

        return mappedBalances;
    }

    private static getLeaveOverviewBalancesFromUnmappedBalances(balances: ResourceHourBalance[]): Record<number, ResourceHourBalance> {
        const mappedBalances: Record<number, ResourceHourBalance> = {};
        for (const balance of balances) {
            if (balance.leaveOverviewId !== null && !mappedBalances[balance.leaveOverviewId]) {
                mappedBalances[balance.leaveOverviewId] = balance;
            }
        }

        return mappedBalances;
    }
}
